/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';

import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, {
	type SaveFilterDialogBaseQuery,
} from '../../common/ui/save-filter-dialog-base/__generated__/SaveFilterDialogBaseQuery.graphql';
import type { UpdateFilterDialogEntryPointEntrypointProps } from './UpdateFilterDialogEntryPoint.entrypoint.types.tsx';

type EntryPointParams = {
	filterAri?: string;
};

type UpdateFilterDialogEntryPointComponent = EntryPointComponent<
	{
		filterDataQuery: SaveFilterDialogBaseQuery;
	},
	{},
	UpdateFilterDialogEntryPointEntrypointProps,
	{}
>;

export const updateFilterDialogEntryPoint: EntryPoint<
	UpdateFilterDialogEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<UpdateFilterDialogEntryPointComponent>(
		/* webpackChunkName: "async-issue-navigator-update-filter-dialog-content" */ './index.tsx',
	),
	getPreloadProps: ({ filterAri }: EntryPointParams) => ({
		queries: {
			filterDataQuery: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					filterAri: filterAri ?? '',
					includeFilter: !!filterAri,
				},
			},
		},
	}),
});
